import React, { useMemo } from 'react';
import {
  Button, TextField, Dialog,
  DialogActions, DialogContent,
  DialogContentText, DialogTitle, Grid,
  makeStyles,
  FormHelperText
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';

interface Prop {
  open: boolean,
  handleClose: () => void,
  handleChangeForgetForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void,
  forgetSubmit: () => void,
  reqItem: {
    companyName: boolean,
    name: boolean,
    userId: boolean
  }
}
const useStyles = makeStyles((theme) => ({
  form: {
    width: "80%", // Fix IE 11 issue.
  },
  dialogtitle: {
    display: 'flex',
    alignItems: 'center',
    color: 'red',
  }
}));


const ForgetFrom: React.FC<Prop> = (props) => {
  const classes = useStyles()
  const { open, handleClose, handleChangeForgetForm, forgetSubmit, reqItem } = props
  const check = useMemo(() => {
    return (reqItem.companyName || reqItem.name || reqItem.userId)
  }, [reqItem])
  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"><div className={classes.dialogtitle}><WarningIcon />{"パスワードをリセットしますか?"}</div></DialogTitle>
      <DialogContent>
        <DialogContentText>
          この操作を行うと、CISヘルプライン管理者にパスワードリセット依頼を送信することができます。
      </DialogContentText>
        <DialogContentText>
          パスワードのリセットを行うと登録されている全てのメンバーに影響します。
      </DialogContentText>
        <Grid container
          justify="flex-start">
          <Grid item xs={12}>
            <TextField className={classes.form} margin="dense" id="userId" name="userId" label="ユーザー名" onChange={handleChangeForgetForm} required autoFocus error={reqItem.userId} />
            {reqItem.userId && <FormHelperText error>必須項目です</FormHelperText>}
          </Grid>
          <Grid item xs={12}>
            <TextField className={classes.form} margin="dense" id="companyName" name="companyName" label="会社名" onChange={handleChangeForgetForm} required error={reqItem.companyName} />
            {reqItem.companyName && <FormHelperText error>必須項目です</FormHelperText>}
          </Grid>
          <Grid item xs={12}>
            <TextField className={classes.form} margin="dense" id="name" name="name" label="氏名" onChange={handleChangeForgetForm} required error={reqItem.name} />
            {reqItem.name && <FormHelperText error>必須項目です</FormHelperText>}
          </Grid>
        </Grid>
        <DialogContentText>
          数日経ってもリセットパスワードのお知らせが届かない場合は、お問合せ下さい。
      </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          キャンセル
      </Button>
        <Button onClick={forgetSubmit} color="primary" disabled={check}>
          送信
      </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ForgetFrom
